module.exports = __webpack_public_path__ + "static/media/stop-circle.cc7f1826.svg";